import { render, staticRenderFns } from "./createArchiving.vue?vue&type=template&id=14ef4b3f&scoped=true&"
import script from "./createArchiving.vue?vue&type=script&lang=js&"
export * from "./createArchiving.vue?vue&type=script&lang=js&"
import style0 from "./createArchiving.vue?vue&type=style&index=0&id=14ef4b3f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ef4b3f",
  null
  
)

export default component.exports